module.exports = __webpack_public_path__ + "img/burgermenu.d537f64e.svg";